import {
  Component,
  ElementRef,
  EventEmitter, inject,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AsmService } from '@spartacus/asm/core';
import { AsmConfig, CustomerSearchPage } from '@spartacus/asm/root';
import {
  FeatureConfigService,
  User
} from '@spartacus/core';
import { lastValueFrom, Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SharedService } from 'src/app/shared/services/shared.service';
import { VscaAsmComponentService } from '../../service/vsca-asm-component.service';
import { BaseService } from '../../../shared/services/base.service';
@Component({
    selector: 'vsca-cx-customer-selection',
    templateUrl: './vsca-customer-selection.component.html',
    styleUrls: ['./vsca-customer-selection.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        '(document:click)': 'onDocumentClick($event)',
    },
    standalone: false
})
export class VscaCustomerSelectionComponent implements OnInit, OnDestroy {
  private featureConfigService = inject(FeatureConfigService);

  customerSelectionForm: FormGroup;
  private subscription = new Subscription();
  searchResultsLoading$: Observable<boolean>;
  searchResults: Observable<CustomerSearchPage>;
  selectedCustomer: User;
  accountId;
  isAccountdId = false;
  isAccountSearch = false;
  @Output()
  submitEvent = new EventEmitter<{ customerId: string }>();

  @ViewChild('resultList') resultList: ElementRef;
  @ViewChild('searchTerm') searchTerm: ElementRef;

  constructor(
    private fb: FormBuilder,
    private asmService: AsmService,
    private config: AsmConfig,
    private sharedService: SharedService,
    private readonly activatedRoute: ActivatedRoute,
    protected asmComponentService: VscaAsmComponentService,
    private baseService: BaseService
  ) {}

  ngOnInit(): void {
    this.customerSelectionForm = this.fb.group({
      searchTerm: ['', Validators.required],
    });
    this.asmService.customerSearchReset();
    this.searchResultsLoading$ = this.asmService.getCustomerSearchResultsLoading();
    this.searchResults = this.asmService.getCustomerSearchResults();

    this.subscription.add(
      this.customerSelectionForm.controls.searchTerm.valueChanges
        .pipe(debounceTime(300))
        .subscribe((searchTermValue) => {
          this.handleSearchTerm(searchTermValue);
        })
    );
    this.activatedRoute.queryParams.subscribe((res) => {
      if (res && res?.accountId) {

        this.isAccountdId = true;
        this.isAccountSearch = true;
        this.asmService.customerSearch({
          query: res?.accountId,
// TODO:Spartacus - The type of property 'asm: { agentSessionTimer?: { startingDelayInSeconds?: number; }; customerSearch?: { maxResults?: number; }; customerList?: { pageSize?: number; showAvatar?: boolean; columns?: { headerLocalizationKey: string; icon?: { symbol?: ICON_TYPE; captionLocalizationKey?: string; }; renderer?: (customer: User) => string; actionType?: CustomerListColumnActionType; }[]; }; userIdHttpHeader?: { enable?: boolean; }; }' changed to: 'asm: { agentSessionTimer?: { startingDelayInSeconds?: number; }; customerSearch?: { maxResults?: number; }; customerList?: { pageSize?: number; showAvatar?: boolean; columns?: { headerLocalizationKey: string; icon?: { symbol?: ICON_TYPE; captionLocalizationKey?: string; }; renderer?: (customer: User) => string; actionType?: CustomerListColumnActionType; }[]; }; asmSessionSupport?: { enabled?: boolean; }; userIdHttpHeader?: { enable?: boolean; }; createCustomer?: { enable?: boolean; }; }'
          pageSize: this.config.asm.customerSearch.maxResults,
        });
        this.searchResultsLoading$ = null;
        this.searchResults = null;
        this.asmService.getCustomerSearchResults().subscribe((res1) => {
          if (res1 && this.isAccountSearch) {
            this.isAccountSearch = false;
            this.submitEvent.emit({ customerId: res1?.entries[0]?.uid });
          }
        });
      }
    });
  }

  private handleSearchTerm(searchTermValue: string) {
    if (
      Boolean(this.selectedCustomer) &&
      searchTermValue !== this.selectedCustomer.name
    ) {
      this.selectedCustomer = undefined;
    }
    if (Boolean(this.selectedCustomer)) {
      return;
    }
    this.asmService.customerSearchReset();
    if (searchTermValue.trim().length >= 9) {
      this.isAccountSearch = false;
      this.asmService.customerSearch({
        query: searchTermValue,
// TODO:Spartacus - The type of property 'asm: { agentSessionTimer?: { startingDelayInSeconds?: number; }; customerSearch?: { maxResults?: number; }; customerList?: { pageSize?: number; showAvatar?: boolean; columns?: { headerLocalizationKey: string; icon?: { symbol?: ICON_TYPE; captionLocalizationKey?: string; }; renderer?: (customer: User) => string; actionType?: CustomerListColumnActionType; }[]; }; userIdHttpHeader?: { enable?: boolean; }; }' changed to: 'asm: { agentSessionTimer?: { startingDelayInSeconds?: number; }; customerSearch?: { maxResults?: number; }; customerList?: { pageSize?: number; showAvatar?: boolean; columns?: { headerLocalizationKey: string; icon?: { symbol?: ICON_TYPE; captionLocalizationKey?: string; }; renderer?: (customer: User) => string; actionType?: CustomerListColumnActionType; }[]; }; asmSessionSupport?: { enabled?: boolean; }; userIdHttpHeader?: { enable?: boolean; }; createCustomer?: { enable?: boolean; }; }'
        pageSize: this.config.asm.customerSearch.maxResults,
      });
      this.searchResultsLoading$ =
        this.asmService.getCustomerSearchResultsLoading();
      this.searchResults = this.asmService.getCustomerSearchResults();
    }
  }

  selectCustomerFromList(customer: User) {
    this.selectedCustomer = customer;
    this.customerSelectionForm.controls.searchTerm.setValue(
      this.selectedCustomer.name
    );
    this.asmService.customerSearchReset();
  }

  onSubmit(): void {
    if (this.customerSelectionForm.valid && Boolean(this.selectedCustomer)) {
      this.submitEvent.emit({ customerId: this.selectedCustomer.uid });
      if (!this.featureConfigService.isEnabled('authorizationCodeFlowByDefault')) {
        void lastValueFrom(this.baseService.post(`/users/${this.selectedCustomer.uid}/loginnotification`, {}));
      }
    } else {
      this.customerSelectionForm.markAllAsTouched();
    }
  }

  onDocumentClick(event) {
    if (Boolean(this.resultList)) {
      if (
        this.resultList.nativeElement.contains(event.target) ||
        this.searchTerm.nativeElement.contains(event.target)
      ) {
        return;
      } else {
        this.asmService.customerSearchReset();
      }
    }
  }

  closeResults() {
    this.asmService.customerSearchReset();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.asmService.customerSearchReset();
  }
}
